import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import BackButton from '../mobile-menu-item/BackButton';
import MobileMenuItem from '../mobile-menu-item/MobileMenuItem';
import styles from './MobileMenu.scss';
import notifyAnalytics from '../notify-analytics';
import formatTestId from '../../../utils/test-id/format-testid';

const NestedMenuList = ({ name, child, hierarchy }) => (
  <li className={styles.nestedMenuItem}>
    <h4 className={styles.mobileMenu__nestedHeading}>{name}</h4>
    <ul
      className={classNames(
        styles.mobileMenuList__nested,
        styles.mobileMenuList
      )}
    >
      {child.map(({ id, name: childName, url }) => (
        <MobileMenuItem
          key={id}
          label={childName}
          url={url}
          hierarchy={hierarchy}
        />
      ))}
    </ul>
  </li>
);

const NestedMenu = ({ data, hierarchy: parentHierarchy, onNavigateBack }) => (
  <div
    className={classNames(styles.subMenu, styles.categoryLevelMenu)}
    role="menu"
  >
    {data.backLabel && (
      <BackButton label={data.backLabel} onClick={onNavigateBack} />
    )}
    <h3 className={styles.mobileMenu__name}>
      {data.url ? (
        <a
          href={data.url}
          alt={data.name}
          onClick={() => notifyAnalytics(data.name)}
          data-testid={formatTestId(data.name, 'nav-heading-')}
        >
          {data.name}
        </a>
      ) : (
        data.name
      )}
    </h3>
    <ul className={styles.mobileMenuList}>
      {data?.child?.map(({ id, name, url, child }) =>
        child?.length > 0 ? (
          <NestedMenuList
            key={id}
            name={name}
            child={child}
            hierarchy={[...parentHierarchy, data.name, name]}
          />
        ) : (
          <MobileMenuItem
            key={id}
            label={name}
            url={url}
            hierarchy={[...parentHierarchy, data.name]}
          />
        )
      )}
    </ul>
  </div>
);

NestedMenu.defaultProps = {
  onNavigateBack: undefined,
  hierarchy: [],
  data: {},
};

NestedMenu.propTypes = {
  data: PropTypes.shape({
    backLabel: PropTypes.string,
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    child: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        url: PropTypes.string,
      })
    ),
  }),
  onNavigateBack: PropTypes.func,
  hierarchy: PropTypes.arrayOf(PropTypes.string),
};

export default NestedMenu;
